export const AdditionalField = {
  path: '/additional_fields',
  name: 'additional_fields',
  component: () => import('@/views/Setting/AdditionalField/AdditionalFieldPage.vue'),
  children: [
    {
      path: '/additional_fields/add',
      name: 'additional_fields.add',
      component: () => import('@/views/Setting/AdditionalField/Form/AdditionalFieldForm.vue'),
      props: { addAction: true }
    },
    {
      path: '/additional_fields/edit/:id',
      name: 'additional_fields.edit',
      component: () => import('@/views/Setting/AdditionalField/Form/AdditionalFieldForm.vue'),
      props: { updateAction: true }
    },
    {
      path: '/additional_fields/delete/:id',
      name: 'additional_fields.delete',
      component: () => import('@/views/Setting/AdditionalField/Form/AdditionalFieldForm.vue'),
      props: { deleteAction: true }
    },
    {
      path: '/additional_fields/view/:id',
      name: 'additional_fields.view',
      component: () => import('@/views/Setting/AdditionalField/Form/AdditionalFieldForm.vue'),
      props: { viewAction: true }
    }
  ]
}